// extracted by mini-css-extract-plugin
module.exports = {"login-notice-wrapper":"LoginNotice_login-notice-wrapper__UkHV6"};